
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
    providedIn:'root'
})
export class AuthGuard implements CanActivate {
    constructor(private router:Router,private authService:AuthService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        var islogin = this.authService.isAuthorized();
        if (islogin) {
            return true;
        }else {
            localStorage.removeItem("auth_token");
            this.router.navigate(['auth/login']);
            return false;
        }
    }
}
